import { EmptyResultsFiltersPlaceholder, usePortalMode, usePortalStore } from '@servicetitan/cp-ui';
import classNames from 'classnames';
import { observer } from 'mobx-react';
import { FC, Fragment } from 'react';
import { InvoiceV2 } from '../../../api/portal-invoices.api';
import { InvoicesListItem } from './invoices-list-item';
import * as Styles from './invoices-list.module.less';

interface InvoicesListProps {
    filtered: boolean;
    invoices?: InvoiceV2[];
    resetFilters(): void;
}

export const InvoicesList: FC<InvoicesListProps> = observer(props => {
    const { filtered, invoices, resetFilters } = props;

    const mode = usePortalMode();
    const portalStore = usePortalStore();

    const handleViewInvoiceClick = (invoiceId: string) => {
        portalStore.event('redirect', ['invoice', { invoiceId }]);
    };

    return (
        <Fragment>
            {!invoices?.length && (
                <EmptyResultsFiltersPlaceholder
                    title={
                        filtered ? 'No invoices records found' : 'All current invoices are paid!'
                    }
                    showFilterButtons={filtered}
                    onClearFiltersClick={resetFilters}
                    size="small"
                />
            )}

            {!!invoices && invoices?.length > 0 && (
                <div
                    className={classNames(Styles.list, {
                        [Styles.listColumn]: !mode.desktop,
                    })}
                >
                    {invoices.map(invoice => (
                        <InvoicesListItem
                            key={invoice.id}
                            invoice={invoice}
                            onViewInvoiceClick={handleViewInvoiceClick}
                        />
                    ))}
                </div>
            )}
        </Fragment>
    );
});
